import { useSelector } from 'react-redux'

import appSelectors from 'App/duck/selectors'
import clubCardSelectors from 'features/account/club-card/duck/selectors'
import { trackEventAdapter } from 'helpers/tracking'

type EventType = {
  eventType: string
  eventCategory: string
  eventId: string
  eventLabel?: string
}

const staticData = {
  category_id: 'myAccount',
}

export type TrackEvent = (eventType: EventType) => () => void

const useTrackAccountClickEvent = (): TrackEvent => {
  const appDataForTrackingPageView = useSelector(appSelectors.getAppPageViewTrackingData)
  const currentTier = useSelector(clubCardSelectors.getCurrentTier)

  const trackEvent =
    ({ eventType, eventCategory, eventId, eventLabel }: EventType = {} as EventType) =>
    () => {
      if (eventType && eventCategory && eventId) {
        trackEventAdapter({
          ...staticData,
          ...appDataForTrackingPageView,
          customer_club_level: `tier ${currentTier}`,
          event_type: eventType,
          event_category: eventCategory,
          event_id: eventId,
          ...(eventLabel && { event_label: eventLabel }),
        })
      }
    }

  return trackEvent
}

export default useTrackAccountClickEvent
